import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { StorageService } from "../_services";
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators'

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private storageService: StorageService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let offset = (request.url[0] == '/') ? 1 : 0;
    let prefix = request.url.substr(offset, 7);

    if (prefix != "assets/" && request.url.indexOf('s3.amazonaws.com') == -1) {
      // add authorization header with jwt token if available
      let authToken = this.storageService.get('authToken');
      const profilerEnabled = this.storageService.get('profilerEnabled');
      const cprofilerEnabled = this.storageService.get('cprofilerEnabled');

      let baseUrl = environment.apiUrl;
      const isAskSolvpathApi = request.headers.get('ask_solvpath_api') === "true";

      if (request.headers.get('chargeback_api') === "true") {
        baseUrl = environment.cbApiUrl
      } else if (request.headers.get('email_api') === "true") {
        baseUrl = environment.emailApiUrl
      } else if (isAskSolvpathApi) {
        baseUrl = environment.askSolvpathApiUrl
      }

      let updatedReq = {url: `${baseUrl}/${request.url}`};

      if (authToken || profilerEnabled || cprofilerEnabled) {
        updatedReq['setHeaders'] = {};

        if (authToken) {
          updatedReq['setHeaders']['Authorization'] = `Token ${authToken}`;
        }

        if (profilerEnabled) {
          updatedReq['setHeaders']['Profiler-Enabled'] = 'true';
        }

        if (cprofilerEnabled) {
          updatedReq['setHeaders']['Cprofiler-Enabled'] = 'true';
        }
      }

      if (request.headers.has('chargeback_api')) {
        request = request.clone({
          ...updatedReq,
          headers: request.headers.delete('chargeback_api')
        });
      } else if (request.headers.has('email_api')) {
        request = request.clone({
          ...updatedReq,
          headers: request.headers.delete('email_api')
        });
      } else if (request.headers.has('ask_solvpath_api')) {
        request = request.clone({
          ...updatedReq,
          headers: request.headers.delete('ask_solvpath_api')
        });
      } else {
        request = request.clone(updatedReq);
      }
    }

    return next.handle(request).pipe(map((event: HttpEvent<any>) => {
      return event;
    }), catchError((err: any, caught) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          //invalid token so force user to login again
          this.storageService.remove('authToken'); // token is invalid so delete it
          this.router.navigate(['/user/login'], {queryParams: {returnUrl: request.url}});
        }
      }

      return throwError(err);
    }));
  }
}
